var global = require('../internals/global');
var inspectSource = require('../internals/inspect-source');

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/native-weak-map.js
// module id = 240
// module chunks = 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35